import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../hooks/useSeo';
import './Pages.css';

function ProactiveITManagement() {
  useSeo(
    'Proactive IT Management | Rev-Tech Services',
    'Rev-Tech proactive IT management keeps systems healthy and secure with monitoring, patching, and performance tuning.',
    {
      canonical: 'https://www.rev-technology.com/services/proactive-it-management'
    }
  );

  return (
    <div className="page">
      <h1>Proactive IT Management</h1>
      <section className="content-section">
        <p>
          Our proactive IT management service is designed to keep your systems running smoothly and securely before
          small issues become major problems. We monitor your desktops, servers, and network devices around the clock,
          apply critical patches, and optimize performance so your business can stay productive.
        </p>
      </section>

      <section className="content-section">
        <h2>What&apos;s Included</h2>
        <ul className="values-list">
          <li><strong>24/7 monitoring:</strong> Continuous system and network visibility to identify risk early.</li>
          <li><strong>Patching & maintenance:</strong> Regular updates for operating systems, firmware, and applications.</li>
          <li><strong>Performance tuning:</strong> Proactive optimization to prevent slowdowns and outages.</li>
          <li><strong>Inventory management:</strong> Asset tracking for systems, devices, and software licenses.</li>
        </ul>
      </section>

      <section className="content-section">
        <h2>Why it matters</h2>
        <p>
          Proactive IT management reduces downtime, lowers repair costs, and frees your team to focus on business priorities.
          With Rev-Tech managing the details, your technology supports your growth instead of holding it back.
        </p>
      </section>

      <Link to="/services" className="cta-button">Back to Services</Link>
    </div>
  );
}

export default ProactiveITManagement;
